import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import FixaPill from "@coworker/apprestructured/src/shared/wrappers/FixaPill/FixaPill";
import CheckmarkIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CheckmarkIconPath";
import PlusIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PlusIconPath";
import { useTranslation } from "@coworker/locales";
import styles from "./tag-list.module.css";

type TagListProps = {
  tags: string[];
  selectedTags: string[];
  onToggleTag: (tag: string) => void;
  isAddingTag: boolean;
  newTagValue: string;
  onNewTagValueChange: (value: string) => void;
  onStartAddTag: () => void;
  onConfirmAddTag: () => void;
  onCancelAddTag: () => void;
};

export const TagList = ({
  tags,
  selectedTags,
  onToggleTag,
  isAddingTag,
  newTagValue,
  onNewTagValueChange,
  onStartAddTag,
  onConfirmAddTag,
  onCancelAddTag,
}: TagListProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles["tagList"]}>
      {tags.map((tag) => (
        <FixaPill
          key={tag}
          label={tag}
          size="small"
          selected={selectedTags.includes(tag)}
          onClick={() => onToggleTag(tag)}
        />
      ))}

      {isAddingTag ? (
        <FixaInputField
          id="newTag"
          type="text"
          className={styles["newTagInput"]}
          value={newTagValue}
          autoFocus
          onChange={(e) => onNewTagValueChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onConfirmAddTag();
            } else if (e.key === "Escape") {
              onCancelAddTag();
            }
          }}
          ssrIcon={CheckmarkIconPath}
          iconPosition="trailing"
          iconOnClick={onConfirmAddTag}
        />
      ) : (
        <FixaPill
          aria-label={t("addNewTagString")}
          size="small"
          leadingIcon={PlusIconPath}
          onClick={onStartAddTag}
          className={styles["newTagButton"]}
        />
      )}
    </div>
  );
};
